export default __webpack_public_path__ + "static/media/campleaders.f8aaadbd.jpg";